import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "assets/css/main.css";
import "assets/css/modal.css";
import "assets/css/header.css";
import "assets/js/include.js";
import "assets/js/modal.js";

// pages for this kit
import Index from "views/Index.js";
import LoginPage from "views/screens/LoginPage.js";
// import SignUpPage from "views/screens/SignUp.js";
// import ResetPassword from "views/screens/ResetPasswordPage";
// import DashboardPage from "views/screens/DashboardPage";
import MyProfile from "views/screens/myprofile/index.js";
import CheckPermission from "views/screens/CheckPermission.js";
import Dashboard from "views/screens/dashboard/index.js";
import BusinessLine from "views/screens/businessline/index.js";
import CustomerGroup from "views/screens/customergroup/index.js";
// import Customer from "views/screens/customer/index.js";
import UserEntry from "views/screens/userentry/index.js";
import Team from "views/screens/team/index.js";
import Designation from "views/screens/designation/index.js";
import Department from "views/screens/department/index.js";
import InvoiceUpload from "views/screens/invoiceupload/index.js";
import InvoiceAndOrderMap from "views/screens/invoiceandordermap/index.js";
import InvoiceList from "views/screens/invoicelist/index.js";
import InvoiceApproval from "views/screens/invoiceapproval/index.js";
import InvoiceAdjustmentReport from "views/screens/invoiceadjustmentreport/index.js";

import PaymentReceive from "views/screens/paymentreceive/index.js";
import MRVerification from "views/screens/mrverification/index.js";
import CollectorAssignment from "views/screens/collectorassignment/index.js";
import MRCollectionStatus from "views/screens/mrcollectionstatus/index.js";
import MRCollectionStatusCheck from "views/screens/mrcollectionstatuscheck/index.js";
import AllocateInvoice from "views/screens/allocateinvoice/index.js";
import CollectionVerification from "views/screens/collectionverification/index.js";

import BillGenerate from "views/screens/billgenerate/index.js";
// import Machine from "views/screens/machine/index.js";
// import Machineparts from "views/screens/machineparts/index.js";
// import Machinemodel from "views/screens/machinemodel/index.js";
// import Machineserial from "views/screens/machineserial/index.js";
import UserRole from "views/screens/userrole/index.js";
import RoleToMenuPermission from "views/screens/roletomenupermission/index.js";
// import Feedback from "views/screens/feedback/index.js";
import Client from "views/screens/client/index.js";
// import Branch from "views/screens/branch/index.js";
import AuditLog from "views/screens/auditlog/index.js";
import ErrorLog from "views/screens/errorlog/index.js";
import UserContextProvider from './context/user-info-context';

// import { QueryClient, QueryClientProvider, useQuery } from 'react-query';

// const queryClient = new QueryClient()

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

let userInfo = null;

userInfo = {
  FacilityId: 0,
  FacilityName: 'NA',
  LangId: 'en_GB'
};

ReactDOM.render(
  <UserContextProvider userInfo={userInfo}>
    {/* <QueryClientProvider client={queryClient}> */}
      <BrowserRouter basename={process.env.REACT_APP_BASE_NAME}>
        <Suspense>
          <Switch>

            <Route path="/home" render={(props) => <Index {...props} />} />
            <Route path="/login" render={(props) => <LoginPage {...props} />} />
            {/* <Route path="/signup" render={(props) => <SignUpPage {...props} />} /> */}
            {/* <Route path="/reset-password" render={(props) => <ResetPassword {...props} />} /> */}
            {/* <Route path="/dashboard" render={(props) => <DashboardPage {...props} />} /> */}
      			<Route path="/myprofileweb" render={(props) => <MyProfile {...props} />} />
            <Route path="/check-permission" render={(props) => <CheckPermission {...props} />} />
            <Route path="/dashboard" render={(props) => <Dashboard {...props} />} />
            <Route path="/businessline" render={(props) => <BusinessLine {...props} />} />
            <Route path="/customergroup" render={(props) => <CustomerGroup {...props} />} />
            {/* <Route path="/customer" render={(props) => <Customer {...props} />} /> */}
            <Route path="/userentry" render={(props) => <UserEntry {...props} />} />
            <Route path="/team" render={(props) => <Team {...props} />} />
            <Route path="/designation" render={(props) => <Designation {...props} />} />
            <Route path="/department" render={(props) => <Department {...props} />} />
           
            <Route path="/invoiceupload" render={(props) => <InvoiceUpload {...props} />} />
            <Route path="/invoiceandordermap" render={(props) => <InvoiceAndOrderMap {...props} />} />
            <Route path="/invoicelist" render={(props) => <InvoiceList {...props} />} />
            <Route path="/invoiceapproval" render={(props) => <InvoiceApproval {...props} />} />
            <Route path="/invoiceadjustmentreport" render={(props) => <InvoiceAdjustmentReport {...props} />} />


            <Route path="/paymentreceive" render={(props) => <PaymentReceive {...props} />} />
            <Route path="/mrverification" render={(props) => <MRVerification {...props} />} />
            <Route path="/collectorassignment" render={(props) => <CollectorAssignment {...props} />} />
            <Route path="/mrcollectionstatuscheck" render={(props) => <MRCollectionStatusCheck {...props} />} />
            <Route path="/mrcollectionstatus" render={(props) => <MRCollectionStatus {...props} />} />
            <Route path="/allocateinvoice" render={(props) => <AllocateInvoice {...props} />} />
            <Route path="/collectionverification" render={(props) => <CollectionVerification {...props} />} />
          
          
          
          
            <Route path="/billgenerate" render={(props) => <BillGenerate {...props} />} />

            <Route path="/userrole" render={(props) => <UserRole {...props} />} />
            <Route path="/roletomenupermission" render={(props) => <RoleToMenuPermission {...props} />} />
            <Route path="/client" render={(props) => <Client {...props} />} />
            <Route path="/auditlog" render={(props) => <AuditLog {...props} />} />
            <Route path="/errorlog" render={(props) => <ErrorLog {...props} />} />
            <Route path="/" render={(props) => <Index {...props} />} />

          </Switch>
        </Suspense>
      </BrowserRouter>
    {/* </QueryClientProvider> */}
  </UserContextProvider>,
  document.getElementById("root")
);
